import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = null as Brand[] | null;

const slice = createSlice({
  name: '$brands',
  initialState,
  reducers: {
    setBrands(state, action: PayloadAction<Brand[] | null>) {
      return action.payload;
    },
  },
});

export const { setBrands } = slice.actions;
export default slice.reducer;
